import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { extractValueFromParams, isNullOrEmpty, getParentRoutePath } from '@awp/core/utils';
import { MENU_TOKEN, MenuService } from '@awp/app-common';

@Injectable({
  providedIn: 'root',
})
export class CheckMenuExistsGuard implements CanActivate {

  constructor(
    private router: Router,
    @Inject(MENU_TOKEN) private menuService: MenuService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | UrlTree {
    let menuId = route.paramMap.get('menuId');
    let themeId = extractValueFromParams(route, 'themeId');

    return this.menuService.values.pipe(
      map(items => {
        const item = items.find(p => p.url === menuId);
        const parentRoutePath = getParentRoutePath(route);
        if (item != null && item.contentUrl != null
          && (parentRoutePath == null || parentRoutePath === themeId || isNullOrEmpty(item.parentUrl))) {
          return true;
        }

        return this.router.createUrlTree(['/', themeId, 'page', 'not-found']);
      }),
      take(1)
    );
  }

}
